module.exports = __webpack_public_path__ + "img/qfqzdw-icon.fd8214c4.png";